// @ts-expect-error https://vite.dev/config/build-options.html#build-modulepreload
import "vite/modulepreload-polyfill";
window.global ||= window;
// TODO: Remove polyfills
import "../../grindex/Client/common/js/polyfill/polyfills.js";
import "../../grindex/Client/common/js/vendor/vendor.js";
import "../scss/legacy-areas/grindex/Client/common/scss/main-grindex.scss";

import { grindexModules } from "../../grindex/Client/common/js/pages/main/config.js";
import { createGrindexApp } from "../../grindex/Client/common/js/createGrindexApp.js";
import { initializeFontAwesome } from "./core/fontawesome.js";

initializeFontAwesome();
const modules = [...grindexModules];
createGrindexApp({ modules });
